import React, { useState, useEffect } from 'react';
import "../../../assets/css/doctor/doctorpages/History.css";
import DoctorMasterLayout from "../doctorlayouts/DoctorMasterLayout";
import { fetchTherapyHistory } from "../../../Services/therapyHistoryService";

// Duration filhaal fixed hai (backend mein store nahi ho rahi)
const FIXED_DURATION = "45 mins";

export default function TherapyHistory() {
  const [sessions, setSessions] = useState([]);
  const [stats, setStats] = useState({
    total_sessions: 0,
    total_revenue: 0,
    completed_count: 0,
    upcoming_count: 0,
    cancelled_count: 0,
  });

  const [activeFilter, setActiveFilter] = useState('Completed');
  const [selectedSession, setSelectedSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadHistory(activeFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter]);

  const loadHistory = async (filter) => {
    try {
      setLoading(true);
      setError(null);

      const statusParam = filter.toLowerCase(); // 'total' | 'completed' | 'upcoming' | 'cancelled'
      const result = await fetchTherapyHistory(statusParam);

      if (result.success) {
        setStats(result.stats);
        setSessions(result.data.data); // Laravel paginate() -> actual array "data.data" mein hota hai
      } else {
        setError('Failed to load session history.');
      }
    } catch (err) {
      console.error(err);
      setError('Something went wrong while loading history.');
    } finally {
      setLoading(false);
    }
  };

  const openDetails = (session) => setSelectedSession(session);
  const closeDetails = () => setSelectedSession(null);

  // Backend status values (completed/confirmed/cancelled/rejected) ko frontend labels se map karna
  const statusLabelMap = {
    completed: 'Completed',
    confirmed: 'Upcoming',
    cancelled: 'Cancelled',
    rejected: 'Cancelled',
    pending: 'Pending',
  };

  const displayStatus = (status) => statusLabelMap[status] || status;

  return (
    <DoctorMasterLayout>
      <div className="th-therapy-history-body">
        <div className="th-therapy-history-container">

          {/* Header */}
          <header className="th-therapy-header">
            <h1 className="th-therapy-title">Smart Therapy Session History</h1>
            <p className="th-therapy-subtitle">Manage and track all your therapy sessions</p>
          </header>

          {/* Statistics Cards */}
          <div className="th-therapy-stats-cards">
            <div className="th-therapy-stat-card">
              <div className="th-therapy-stat-icon-box">
                <svg className="th-therapy-stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div className="th-therapy-stat-info">
                <h3 className="th-therapy-stat-value">{stats.total_sessions}</h3>
                <p className="th-therapy-stat-label">Total Sessions</p>
              </div>
            </div>
            <div className="th-therapy-stat-card">
              <div className="th-therapy-stat-icon-box">
                <svg className="th-therapy-stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <div className="th-therapy-stat-info">
                <h3 className="th-therapy-stat-value">Rs. {Number(stats.total_revenue).toLocaleString()}</h3>
                <p className="th-therapy-stat-label">Total Revenue</p>
              </div>
            </div>
          </div>

          {/* Filter Tabs */}
          <div className="th-filter-tabs-section">
            <button
              className={`th-filter-tab ${activeFilter === 'Total' ? 'th-filter-tab-active' : ''}`}
              onClick={() => setActiveFilter('Total')}
            >
              <span className="th-filter-dot th-filter-dot-total"></span>
              Total
              <span className="th-filter-count">{stats.total_sessions}</span>
            </button>

            <button
              className={`th-filter-tab ${activeFilter === 'Completed' ? 'th-filter-tab-active' : ''}`}
              onClick={() => setActiveFilter('Completed')}
            >
              <span className="th-filter-dot th-filter-dot-completed"></span>
              Completed
              <span className="th-filter-count">{stats.completed_count}</span>
            </button>

            <button
              className={`th-filter-tab ${activeFilter === 'Upcoming' ? 'th-filter-tab-active' : ''}`}
              onClick={() => setActiveFilter('Upcoming')}
            >
              <span className="th-filter-dot th-filter-dot-upcoming"></span>
              Upcoming
              <span className="th-filter-count">{stats.upcoming_count}</span>
            </button>

            <button
              className={`th-filter-tab ${activeFilter === 'Cancelled' ? 'th-filter-tab-active' : ''}`}
              onClick={() => setActiveFilter('Cancelled')}
            >
              <span className="th-filter-dot th-filter-dot-cancelled"></span>
              Cancelled
              <span className="th-filter-count">{stats.cancelled_count}</span>
            </button>
          </div>

          {/* Sessions Table */}
          <section className="th-therapy-table-section">
            <h3 className="th-therapy-section-title">
              {sessions.length} {activeFilter} Session{sessions.length !== 1 ? 's' : ''}
            </h3>

            <div className="th-therapy-table-wrapper">
              <table className="th-therapy-table">
                <thead>
                  <tr>
                    <th>PATIENT</th>
                    <th>AGE</th>
                    <th>GENDER</th>
                    <th>ISSUE</th>
                    <th>PROGRESS</th>
                    <th>DATE</th>
                    <th>FEE</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="th-no-data">Loading sessions...</td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="8" className="th-no-data">{error}</td>
                    </tr>
                  ) : sessions.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="th-no-data">No {activeFilter.toLowerCase()} sessions found</td>
                    </tr>
                  ) : (
                    sessions.map((session) => (
                      <tr key={session.id}>
                        <td>
                          <div className="th-patient-cell">
                            <div className="th-patient-avatar">
                              {session.patient.gender === 'Male' ? '👦' : '👧'}
                            </div>
                            <span className="th-patient-name">{session.patient.name}</span>
                          </div>
                        </td>
                        <td>{session.patient.age} years</td>
                        <td>{session.patient.gender}</td>
                        <td>{session.issue}</td>
                        <td>
                          <span className="th-progress-badge">{session.progress_assessment || '—'}</span>
                        </td>
                        <td>{session.date}</td>
                        <td className="th-fee-cell">Rs. {Number(session.fee).toLocaleString()}</td>
                        <td>
                          <button
                            className="th-view-btn"
                            onClick={() => openDetails(session)}
                          >
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Details Modal */}
        {selectedSession && (
          <div className="th-therapy-modal" onClick={closeDetails}>
            <div className="th-therapy-modal-content" onClick={(e) => e.stopPropagation()}>
              <span className="th-therapy-close" onClick={closeDetails}>&times;</span>
              <h3 className="th-therapy-modal-title">Session Details</h3>

              <div className="th-therapy-modal-body">
                <div className="th-therapy-detail-section">
                  <h4 className="th-therapy-detail-heading">Patient Information</h4>
                  <div className="th-therapy-detail-grid">
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Name:</span>
                      <span className="th-therapy-detail-text">{selectedSession.patient.name}</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Age:</span>
                      <span className="th-therapy-detail-text">{selectedSession.patient.age} years</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Gender:</span>
                      <span className="th-therapy-detail-text">{selectedSession.patient.gender}</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Session Type:</span>
                      <span className="th-therapy-detail-text">{selectedSession.session_type}</span>
                    </div>
                  </div>
                </div>

                <div className="th-therapy-detail-section">
                  <h4 className="th-therapy-detail-heading">Session Details</h4>
                  <div className="th-therapy-detail-item th-full">
                    <span className="th-therapy-detail-label">Issue/Problem:</span>
                    <span className="th-therapy-detail-text">{selectedSession.issue || '—'}</span>
                  </div>
                  <div className="th-therapy-detail-item th-full">
                    <span className="th-therapy-detail-label">Exercises Given:</span>
                    <span className="th-therapy-detail-text">{selectedSession.exercises_given || '—'}</span>
                  </div>
                  {selectedSession.quranic_practice && (
                    <div className="th-therapy-detail-item th-full th-quran-section">
                      <span className="th-therapy-detail-label">📖 Quranic Practice:</span>
                      <span className="th-therapy-detail-text th-quran-verse">{selectedSession.quranic_practice}</span>
                    </div>
                  )}
                  <div className="th-therapy-detail-item th-full">
                    <span className="th-therapy-detail-label">Progress Assessment:</span>
                    <span className="th-therapy-detail-text th-progress-text">{selectedSession.progress_assessment || '—'}</span>
                  </div>
                </div>

                <div className="th-therapy-detail-section">
                  <h4 className="th-therapy-detail-heading">Appointment Details</h4>
                  <div className="th-therapy-detail-grid">
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Date:</span>
                      <span className="th-therapy-detail-text">{selectedSession.date}</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Time:</span>
                      <span className="th-therapy-detail-text">{selectedSession.time}</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Duration:</span>
                      <span className="th-therapy-detail-text">{FIXED_DURATION}</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Status:</span>
                      <span className="th-therapy-status-badge">{displayStatus(selectedSession.status)}</span>
                    </div>
                  </div>
                </div>

                <div className="th-therapy-detail-section">
                  <h4 className="th-therapy-detail-heading">Payment & Next Session</h4>
                  <div className="th-therapy-detail-grid">
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Session Fee:</span>
                      <span className="th-therapy-detail-text th-fee-large">Rs. {Number(selectedSession.fee).toLocaleString()}</span>
                    </div>
                    <div className="th-therapy-detail-item">
                      <span className="th-therapy-detail-label">Next Session:</span>
                      <span className="th-therapy-detail-text th-next-date">{selectedSession.next_session_date || 'Not scheduled'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </DoctorMasterLayout>
  );
}